import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import Feedback from 'questions/Shared/Feedback';
import AudioPreview from 'uikit/AudioPicker/AudioPreview';
import FormattedText from 'uikit/FormattedText';
import VideoPreview from 'uikit/VideoPicker/VideoPreview';

import styles from './Verso.module.scss';

const cx = classNames.bind(styles);

const Verso = ({ className, mediaDuration, question, setMediaDuration, t }) => (
  <div className={cx('container', className)}>
    <FormattedText className={cx('title')}>{question.title}</FormattedText>
    <div className={cx('answer')}>
      <p className={cx('label')}>{t('Questions/Instruction/Verso/answer')}</p>
      <div className={cx('video-wrapper')}>
        {question.solution.user ? (
          <>
            {question.content.answerType === 'video' ? (
              <VideoPreview
                footer={<div className={cx('duration')}>{mediaDuration}</div>}
                setVideoDuration={setMediaDuration}
                video={question.solution.user}
              />
            ) : (
              <AudioPreview
                audio={question.solution.user}
                className={cx('audio-preview')}
              />
            )}
          </>
        ) : (
          <p>{t('Questions/Interview/Verso/no-answer')}</p>
        )}
      </div>
      {question.content.feedback && (
     <Feedback feedback={question.content.feedback} />
      )}
    </div>
  </div>
);

Verso.propTypes = {
  className: PropTypes.string,
  mediaDuration: PropTypes.number.isRequired,
  question: PropTypes.object.isRequired,
  setMediaDuration: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

Verso.defaultProps = {
  className: undefined,
};

export default Verso;
